import * as React from 'react';
import env from 'bench-environment';

export const DashboardRedirect = () => {
  React.useEffect(() => {
    const search = window.location.search;
    const bkToolsTaskManagerLocation = `${env.location.bkTools}/task-manager`;
    window.location.replace(`${bkToolsTaskManagerLocation}${search}`);
  }, []);

  return null;
};
